import WarningAmberTwoToneIcon from '@mui/icons-material/WarningAmberTwoTone';
import { Box, Tooltip, Typography } from '@mui/material';
import { lang } from 'src/utils';

export type LangType = typeof lang;
export const renderSaveComponentSubtitle = (
  lang: LangType,
  isOOEnabled: boolean,
  showWarning?: boolean,
): React.ReactElement => (
  <>
    <Typography fontWeight="bold">
      {lang.saveComponentModal.subTitle}
    </Typography>
    <Typography>
      <ul style={{ paddingLeft: 20, marginTop: 4, marginBottom: 0 }}>
        <li>{lang.saveComponentModal.saveComponentText1}</li>
        <li>{lang.saveComponentModal.saveComponentText2}</li>
        {isOOEnabled && <li>{lang.saveComponentModal.saveComponentText3}</li>}
      </ul>
    </Typography>
    {showWarning && (
      <Box mt={2} display="flex" alignItems="flex-start">
        <Tooltip title={lang.warningAmberTwoToneIconText}>
          <WarningAmberTwoToneIcon
            sx={{
              color: 'warning.main',
              fontSize: 16,
              marginTop: 0.5,
              marginRight: 0.5,
            }}
            aria-label={lang.warningAmberTwoToneIconText}
          />
        </Tooltip>
        <Typography fontWeight="bold" marginRight={0.5}>
          {lang.saveComponentModal.unpublishedProductWarningHeading}
        </Typography>
        <Typography>
          {lang.saveComponentModal.unpublishedProductWarningText}
        </Typography>
      </Box>
    )}
  </>
);
